import { Suspense, lazy } from 'react';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { RouterContext } from '@app/router/context';

const RouterDevtools = import.meta.env.PROD
  ? () => null
  : lazy(() =>
      import('@tanstack/react-router-devtools').then((m) => ({
        default: m.TanStackRouterDevtools,
      })),
    );

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <Outlet />
      <Suspense fallback={null}>
        <RouterDevtools />
      </Suspense>
    </>
  );
}
